module.exports = __webpack_public_path__ + "static/media/ru.a0a0eea4.svg";